
import { Card, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import apiClient from 'helpers/apiService';
import avatar from 'assets/img/team/avatar.webp';
import Avatar from 'components/base/Avatar';
import { TranscriptionInfo } from 'pages/meetings/components/DataDefinitions';
import ContactPickerModal from 'pages/contacts/components/ContactPickerModal';
import { useAuth } from 'providers/AuthProvider';


interface SpeakerData {
    contact_id?: number;
    name: string;
    picture: string;
}

export const MeetingSummary = ({ summaryPoints, className }: { summaryPoints: string[], className?: string }) => {

    const { t } = useTranslation();

    return (
        <>
            <Card className={classNames(className, 'w-100')}>
                <Card.Body>
                    <Card.Title> <h3>{t("MeetingSummary.title")}</h3> </Card.Title>
                    <Card.Text>
                        {summaryPoints.length === 0 &&
                            <Alert style={{ backgroundColor: '#d1e7dd' }}>
                                <Alert.Heading className='text-body'>{t("MeetingSummary.alert.in_progress")}</Alert.Heading>
                                <p className='text-body'>{t("MeetingSummary.alert.message")}</p>
                            </Alert>
                        }
                        <ul style={{ listStyleType: 'none', padding: 0 }} >
                            {summaryPoints.length > 0 && summaryPoints.slice(1).map((point, index) => (
                                <li key={index}>{point}</li>
                            ))}
                        </ul>
                    </Card.Text>
                </Card.Body>
            </Card>

        </>
    );
};


export const MeetingContacts = ({ transcription, className }: {
    transcription: TranscriptionInfo,
    className?: string
}) => {

    const transcription_id = transcription.transcription_id;
    const number_of_speakers = transcription.number_of_speakers;

    const [speakers, setSpeakers] = useState<SpeakerData[]>([]);
    const [contactsLoading, setContactsLoading] = useState<boolean>(false);

    const [showContactPicker, setShowContactPicker] = useState<boolean>(false);
    const [speakerIndex, setSpeakerIndex] = useState<number>(-1);

    const { t } = useTranslation();
    const auth = useAuth();

    //auth.user?.picture

    // Metodo per l'update del contatto sulla conversazione
    const handleContactSelectionUpdate = async (speaker: SpeakerData) => {
        try {
            // Assuming contactIndex is the index of the contact to be updated
            if (speakerIndex >= 0 && speakerIndex < speakers.length) {
                const updatedSpeakers = [...speakers];
                updatedSpeakers[speakerIndex] = speaker;
                setSpeakers(updatedSpeakers);

                // TODO inserire me
                // Extract all contact IDs from the updated contacts array
                //const contactIds = updatedSpeakers.map(speaker => speaker.contact_id);
                const contactInfo = updatedSpeakers
                    .filter(speaker => speaker.contact_id !== undefined && speaker.contact_id !== null)
                    .map(speaker => ({
                        name: speaker.name,
                        contact_id: speaker.contact_id
                    }));



                // Call the backend to update the contacts
                await apiClient.patch(`/v1/conversations/transcription/${transcription_id}/speakers`,
                    { contacts: contactInfo }
                );
            }
        } catch (error) {
            console.error('Error updating contacts', error);
        } finally {
            setSpeakerIndex(-1);
            setShowContactPicker(false);
        }
    };

    const fetchSpeakers = async () => {

        try {
            setContactsLoading(true);
            // Make a GET request to fetch the contacts information, if set, from the backend
            const { data } = await apiClient.get(`/v1/conversations/${transcription_id}/speakers`);

            if (number_of_speakers === null || number_of_speakers === '-') {
                setSpeakers(data);
            } else {
                const numberOfSpeakers = parseInt(number_of_speakers || '0', 10);
                const emptyContacts = Array.from({ length: numberOfSpeakers - data.length }, () => ({
                    name: 'Not assigned',
                    picture: avatar,
                }));

                setSpeakers([...data, ...emptyContacts]);
            }

            //console.log(data);

            setContactsLoading(false);
        } catch (error) {
            console.error('Error fetching contacts data:', error);
        }
    };

    const handleContactSlotSelection = (index: number) => {
        setShowContactPicker(true);
        setSpeakerIndex(index);
    }

    useEffect(() => {
        if (transcription_id) {
            fetchSpeakers();
        }
    }, []);


    return (
        <>
            <ContactPickerModal data={undefined} show={showContactPicker}
                handleClose={() => setShowContactPicker(false)}
                onSave={handleContactSelectionUpdate} />

            <Card className={classNames(className, 'w-100')}>
                <Card.Body>
                    <Card.Title> <h3>{t("MeetingContacts.title")}</h3> </Card.Title>

                    {/* <ContactProfileCard key={index} className="mb-3" data={contact} onSave={handleContactUpdate} /> */}

                    <div className="d-flex">
                        {speakers && speakers.map((speaker, index) => (
                            <>
                                <Avatar size="xl" src={speaker.picture} className="cursor-pointer hover-actions-trigger me-3" key={index}
                                    onClick={() => handleContactSlotSelection(index)} />
                            </>
                        ))}
                    </div>


                </Card.Body>
            </Card>

        </>
    );
};
